module.exports = __webpack_public_path__ + "static/media/right-hand.d94be3b4.png";